import React, { forwardRef } from "react"
import { NavLink } from "react-router"

import { Badge, Collapse } from "react-bootstrap"

const CustomRouterLink = forwardRef((props, ref) => (
  <NavLink ref={ref} {...props} />
))
CustomRouterLink.displayName = "CustomRouterLink"

const SidebarNavListItem = (props) => {
  const {
    title,
    href,
    children,
    icon: Icon,
    badge,
    open: openProp = false,
  } = props

  const [open, setOpen] = React.useState(openProp)

  const handleToggle = () => {
    setOpen((state) => !state)
  }

  if (children) {
    return (
      <li className={`sidebar-item ${open ? "active" : ""}`}>
        <span
          className={`sidebar-link ${open ? "" : "collapsed"}`}
          data-bs-toggle="collapse"
          aria-expanded={open ? "true" : "false"}
          onClick={handleToggle}
        >
          {Icon && <Icon className="feather align-middle" />}{" "}
          <span className="align-middle">{title}</span>
          {badge && (
            <Badge className="badge-sidebar-primary" bg="" size={18}>
              {badge}
            </Badge>
          )}
          {open ? <div /> : <div />}
        </span>
        <Collapse in={open}>
          <ul className="sidebar-dropdown list-unstyled">{children}</ul>
        </Collapse>
      </li>
    )
  }

  return (
    <li className="sidebar-item">
      <CustomRouterLink
        to={href}
        className="sidebar-link"
        data-testid="sidebar-link"
      >
        {Icon && <Icon className="feather align-middle" />}{" "}
        <span className="align-middle">{title}</span>
        {badge && (
          <Badge className="badge-sidebar-primary" bg="" size={18}>
            {badge}
          </Badge>
        )}
      </CustomRouterLink>
    </li>
  )
}

export default SidebarNavListItem
